import { Card, Divider, Typography } from "@mui/material";
import { AppPieChart } from "./charts/PieChart";

export const PieChartCard = ({
  data,
  colors,
  title,
  innerRadius,
  outerRadius,
  boxShadow = 3,
  centerTitle = false,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        boxShadow: boxShadow,
        width: "100%",
        height: "380px",
        p: "15px",
        background: "#1d2637",
        color: "white",
        borderRadius: "12px",
        fontFamily: "Montserrat, serif !important",
        border: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: centerTitle ? "center" : "",
      }}
    >
      <Typography
        sx={{ fontFamily: "Montserrat, serif !important" }}
        variant="overline"
        gutterBottom
      >
        {title}
      </Typography>
      <Divider />

      {data.length > 0 ? (
        <AppPieChart
          data={data}
          colors={colors}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
        />
      ) : (
        <div className="h-full flex text-center">
          <p className="text-white text-center m-auto">No Data</p>
        </div>
      )}
    </Card>
  );
};
